import Vue from 'vue';

export default Vue.filter('slice', (value, start, end) => {
  return (value || '').slice(start, end);
});
